define.alias("ember-cli-string-helpers/helpers/uppercase", "settings/helpers/uppercase");